import type { ISOString, TimestampInMillis } from './dates';
import type { EventTypes } from './events';
import type { Coordinate } from './geoJSON';
import type { UUID } from './identifier';
import type { Feature, Polygon } from 'geojson';

// do not change the second side of this enum, as it's used in the legacy code to render stuff in the map
// also update the geofence transformer to change stuff from string to enum
export enum GeofenceCategory {
  BASE = 'base',
  CLIENT = 'client',
  OTHER = 'other',
  HEADQUARTER = 'headquarter',
  SUPPLY = 'supply',
  MAINTENANCE = 'maintenance',
}

interface Property {
  address: string;
  name: string;
  radius: number;
  coordinate: [number, number];
}
export type GeofenceGeoJSON = Feature<Polygon, Property>;

export interface Geofence {
  id: UUID;
  name: string;
  address: string;
  centerLatLong?: Coordinate;
  radius: number;
  geojson?: GeofenceGeoJSON;
  createdAt: TimestampInMillis;
  category?: GeofenceCategory;
}

export interface GeofenceValidationQuery {
  name: string;
  address: string;
}

export interface GeofenceValidationResponse {
  name: string;
  address: string;
  geocodeAddress: string;
}

export interface GeofenceImportData {
  importId: UUID;
  validAddress: GeofenceValidationResponse[];
  invalidAddress: GeofenceValidationResponse[];
}

export interface GeofenceValidationSummary {
  valid?: GeofenceValidationQuery[];
  invalid?: GeofenceValidationQuery[];
  import_id: UUID;
}

// Geofence Event

type GeofenceEventType = EventTypes.GEOFENCE_IN | EventTypes.GEOFENCE_OUT;

export interface GeofenceEventInfo {
  address: string;
  createdAt: TimestampInMillis;
  geofenceId: UUID;
  name: string;
}

export interface GeofenceEvent {
  id: UUID;
  time: ISOString;
  fleetId: UUID;
  deviceId: string;
  latitude: number;
  longitude: number;
  type: GeofenceEventType;
  info: GeofenceEventInfo;
  vehicleId: UUID;
  driverId?: UUID;
  geofence: Geofence;
}
